import { render } from "./ViewSearch.vue?vue&type=template&id=8a435a48"
import script from "./ViewSearch.vue?vue&type=script&lang=js"
export * from "./ViewSearch.vue?vue&type=script&lang=js"

import "./ViewSearch.vue?vue&type=style&index=0&id=8a435a48&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__